// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2dPEB","green_text":"styles_green_text__2dFEW","info_container":"styles_info_container__PXthu","gridItem":"styles_gridItem__1S4r-"};